import axios from "axios";
import { stage_url } from "../api-urls";
import Headers from "./Headers";


export async function GetRetailerTypes(payload) {  
    return await axios.get(
        `${stage_url}/retailer-type/filter`,
        {
            params: payload, 
            headers: Headers.getHeaders(true),
        }
    );
}


export async function addRetailerType(payload) {
    return await axios.post(
        `${stage_url}/retailer-type`, payload,
        {
            headers: Headers.getDukanHeaders(true),
        }
    );
}


export async function updateRetailerType(payload) {
    return await axios.put(
        `${stage_url}/retailer-type/${payload.id}`, payload,
        {
            headers: Headers.getDukanHeaders(true),
        }
    );
}